import {
  OFFER_INFO_LOAD_REQUESTED,
  OFFER_INFO_FETCH_SUCCEEDED,
  OFFER_INFO_FETCH_FAILED,
  OFFER_VOUCHER_INFO_LOAD_REQUESTED,
  OFFER_VOUCHER_INFO_FETCH_SUCCEEDED,
  OFFER_VOUCHER_INFO_FETCH_FAILED,
  OFFER_INFO_LOAD_AFTER_LOGIN_REQUESTED,
} from '../actions/campaignOfferInfo';

const initialState = {
  data: null,
  error: null,
  fetching: false,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case OFFER_INFO_LOAD_REQUESTED:
    case OFFER_VOUCHER_INFO_LOAD_REQUESTED:
    case OFFER_INFO_LOAD_AFTER_LOGIN_REQUESTED:
      return { ...state, fetching: true };
    case OFFER_INFO_FETCH_SUCCEEDED:
    case OFFER_VOUCHER_INFO_FETCH_SUCCEEDED:
      return {
        ...state, data: payload, error: null, fetching: false,
      };
    case OFFER_INFO_FETCH_FAILED:
    case OFFER_VOUCHER_INFO_FETCH_FAILED:
      return {
        ...state, data: null, error: payload, fetching: false,
      };
    default:
      return state;
  }
}
